module.exports = __webpack_public_path__ + "static/media/savannah-regular.fdc0b3c6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/savannah-regular.otf
// module id = 2251
// module chunks = 50